import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/_auth/$companyId/spaces/$spaceId/')({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: '/$companyId/spaces/$spaceId/projects',
      params: { companyId: params.companyId, spaceId: params.spaceId },
    })
  },
})
